import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

// The country picker, and the "how bad is it" table.
//
// The bucket counts arrive as null until that country's pass has actually been
// computed, and a dash is shown rather than a zero. Honest counts for every
// country would mean running the naming pass for every country, which is the exact
// cost the per-country scoping exists to avoid — so this is the one thing the file
// workflow got for free (the summary fell out of a run that was already global)
// that the pages have to pay for.
const cell = (value) => (value == null ? <span className="text-muted">—</span> : value)

// The reference-data column is a property of the country, not of your progress
// through it: it says whether DiscGolfAPI publishes a catalogue to match this
// country's courses against, and it reads the same before and after a country is
// fully curated. It was headed "Catalogue" and showing "yes", which is exactly what
// a done-marker would look like — hence the wording here, and the caption below the
// table pointing at the columns that do move.
//
// Catalogue-backed countries first, the ones with nothing to match against below them.
// Everything else about the order is the server's — it sends them by course count
// descending, and a stable sort keeps that inside each of the two groups.
const catalogueFirst = (countries) =>
  [...countries].sort((a, b) => Number(b.hasCatalogue) - Number(a.hasCatalogue))

export default function CountrySummary({ countries, loading, selected, onSelect }) {
  if (loading) {
    return (
      <p>
        <Spinner size="sm" className="me-2" />
        Loading countries…
      </p>
    )
  }

  return (
    <>
      <p className="text-muted small mb-1">
        The count columns from <em>Private</em> onwards are the progress: they are what is
        still outstanding for that country, and a country is done when they read zero. A
        dash means that pass has not been computed since the last write — open the
        country and press Recompute to put a number back. <em>Courses</em> counts only
        published courses with at least one public layout, which is all the passes after
        Private look at. <em>Reference data</em> is not progress; it says whether there is
        a catalogue to match this country against at all.
      </p>
      <Table size="sm" hover responsive className="curation-countries">
      <thead>
        <tr>
          <th>Country</th>
          <th>Courses</th>
          <th title="Whether DiscGolfAPI publishes reference course data for this country to match against. Fixed per country — not a measure of progress.">
            Reference data
          </th>
          <th title="Published courses whose every layout is private">Private</th>
          <th>Auto</th>
          <th>Review</th>
          <th>Needs lookup</th>
          <th>Trash</th>
          <th>Merge groups</th>
        </tr>
      </thead>
      <tbody>
        {catalogueFirst(countries).map((row) => (
          <tr
            key={row.country}
            onClick={() => onSelect(row.country)}
            className={row.country === selected ? 'table-active' : undefined}
            style={{ cursor: 'pointer' }}
          >
            <td>
              {row.countryName} <span className="text-muted">({row.countryCode})</span>
            </td>
            <td>{row.courses}</td>
            <td>
              {row.hasCatalogue ? 'available' : <span className="text-muted">none</span>}
            </td>
            <td>{cell(row.privateCandidates)}</td>
            <td>{cell(row.auto)}</td>
            <td>{cell(row.review)}</td>
            <td>{cell(row.needsLookup)}</td>
            <td>{cell(row.hideCandidates)}</td>
            <td>{cell(row.mergeGroups)}</td>
          </tr>
        ))}
      </tbody>
      </Table>
    </>
  )
}
